import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import './ProjectDetail.css'

const ProjectDetail = () => {
    const { id } = useParams()
    const [projectDetail, setProjectDetail] = useState([])
    const [isLoading, setIsLoading] = useState(true)

    useEffect(() => {
        fetch("/projects.json")
            .then(res => res.json())
            .then(data => setProjectDetail(data))
            .finally(() => {
                setIsLoading(false)
            })
    }, [])

    const matchProject = projectDetail.find(project => project.id == id)
    console.log(matchProject);

    return (
        <div style={{ background: "#2B3443", color: "#fff", padding: "75px 0" }}>
            <div className="container">
                {
                    isLoading ? <div class="spinner-border text-success" role="status">
                        <span class="visually-hidden">Loading...</span>
                    </div> : <div className="row gx-5">
                        <div className="col-md-7">
                            <div id="carouselExampleDark" className="border border-success carousel carousel-dark slide rounded-1" data-bs-ride="carousel">
                                <div className="carousel-indicators">
                                    <button type="button" data-bs-target="#carouselExampleDark" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1"></button>
                                    <button type="button" data-bs-target="#carouselExampleDark" data-bs-slide-to="1" aria-label="Slide 2"></button>
                                    <button type="button" data-bs-target="#carouselExampleDark" data-bs-slide-to="2" aria-label="Slide 3"></button>
                                </div>
                                <div className="carousel-inner">
                                    <div className="carousel-item active" data-bs-interval="10000">
                                        <img src={matchProject?.img[1]} className="d-block w-100" alt="..." />
                                    </div>
                                    <div className="carousel-item" data-bs-interval="2000">
                                        <img src={matchProject?.img[2]} className="d-block w-100" alt="..." />
                                    </div>
                                    <div className="carousel-item">
                                        <img src={matchProject?.img[3]} className="d-block w-100" alt="..." />
                                    </div>
                                </div>
                                <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleDark" data-bs-slide="prev">
                                    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                                    <span className="visually-hidden">Previous</span>
                                </button>
                                <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleDark" data-bs-slide="next">
                                    <span className="carousel-control-next-icon" aria-hidden="true"></span>
                                    <span className="visually-hidden">Next</span>
                                </button>
                            </div>
                            <h2 className="py-3 pt-4">{matchProject?.title}</h2>
                            <ul className="nav">
                                {
                                    matchProject?.technology.map(tech => (
                                        <li className="nav-item mx-3 my-2 techStyle">
                                            {tech}
                                        </li>
                                    ))
                                }
                            </ul>
                        </div>
                        <div className="col-md-5">
                            <h2 className="headerStyle pt-2">Features</h2>
                            <ul className="nav flex-column mt-4 my-5">
                                {
                                    matchProject?.des.map(description => (
                                        <li className="nav-item my-3 feature-text"> <i className="fas fa-caret-square-right me-2"></i> {description}</li>
                                    ))
                                }
                            </ul>
                            <a href={matchProject?.live} style={{ textDecoration: "none", color: "#fff" }} target="_blank" rel="noreferrer">
                                <button type="button" className="btn me-2 text-white" style={{ background: "rgb(15 27 46)" }}>Live Preview</button>
                            </a>
                            <a href={matchProject?.client} style={{ textDecoration: "none", color: "#fff" }} target="_blank" rel="noreferrer">
                                <button type="button" className="btn me-2 text-white" style={{ background: "#1A5E9D" }}><i class="fab fa-github"></i> Client</button>
                            </a>
                            {
                                matchProject?.server && <a href={matchProject?.server} style={{ textDecoration: "none", color: "#fff" }} target="_blank" rel="noreferrer">
                                    <button type="button" className="btn btn-danger"><i class="fab fa-github-square"></i> Server</button>
                                </a>
                            }
                        </div>
                    </div>
                }
            </div>
        </div>
    );
};

export default ProjectDetail;